import { useSelector } from 'react-redux';

type InputType =
  | 'active'
  | 'avatar'
  | 'created'
  | 'createdBy'
  | 'credentials'
  | 'credentialsLineOverride'
  | 'currentPermissions'
  | 'currentRoles'
  | 'discipline'
  | 'email'
  | 'emailVerified'
  | 'employmentStatus'
  | 'employmentStatusMessage'
  | 'enableClockInOut'
  | 'enablePayRate'
  | 'enablePaycom'
  | 'enablePto'
  | 'enableTherapistImport'
  | 'firstName'
  | 'lastName'
  | 'licenseNumber'
  | 'modified'
  | 'modifiedBy'
  | 'phone'
  | 'phoneVerified'
  | 'providerId'
  | 'signatureLineOverride'
  | 'timeZone'
  | 'userName'
  | 'uuid';

type ProfileInterface = {
  active: boolean;
  avatar: string | null;
  created: string;
  createdBy: string | null;
  credentials: string;
  /**
   * APIT-655 — free-text overrides for the two lines of the rendered signature block.
   * `null` for every therapist today; `'__BLANK__'` means the line is deliberately
   * suppressed. Nullable, unlike `credentials`, because "unset" is a real state with
   * its own rendering and must not be conflated with an empty string.
   */
  credentialsLineOverride: string | null;
  currentPermissions: string[];
  currentRoles: string[];
  discipline: string;
  email: string;
  emailVerified: boolean;
  // APIT-622 — compliance lockout, enforced by the portal (see src/types/employment-status.ts)
  employmentStatus: string | null;
  employmentStatusMessage: string | null;
  enableClockInOut: boolean;
  enablePayRate: boolean;
  enablePaycom: boolean;
  enablePto: boolean;
  enableTherapistImport: boolean;
  firstName: string;
  lastName: string;
  licenseNumber: string;
  modified: string;
  modifiedBy: string | null;
  phone: string;
  phoneVerified: boolean;
  providerId: string;
  /** APIT-655 — see {@link ProfileInterface.credentialsLineOverride}. */
  signatureLineOverride: string | null;
  timeZone: string;
  userName: string;
  uuid: string;
} | null;

function useCurrentUser(inputs: Array<InputType>) {
  const getTherapistProfileData: ProfileInterface = useSelector(
    (state: any) => state.getTherapistProfileReducer.response?.data
  );

  if (!getTherapistProfileData) {
    return inputs.map(() => null);
  }

  return inputs.map((item: InputType) => getTherapistProfileData[item]);
}

export default useCurrentUser;
